/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Section_Parts_HelpInputs */

const en_ticket_section_parts_help = /** @type {(inputs: Ticket_Section_Parts_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use these only when the ticket involves parts.`)
};

const ja_ticket_section_parts_help = /** @type {(inputs: Ticket_Section_Parts_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品が関係するチケットのみで使用してください。`)
};

const fr_ticket_section_parts_help = /** @type {(inputs: Ticket_Section_Parts_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À utiliser uniquement si le ticket implique des pièces.`)
};

const de_ticket_section_parts_help = /** @type {(inputs: Ticket_Section_Parts_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur verwenden, wenn das Ticket Teile umfasst.`)
};

/**
* | output |
* | --- |
* | "Use these only when the ticket involves parts." |
*
* @param {Ticket_Section_Parts_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_section_parts_help = /** @type {((inputs?: Ticket_Section_Parts_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Section_Parts_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_section_parts_help(inputs)
	if (locale === "ja") return ja_ticket_section_parts_help(inputs)
	if (locale === "fr") return fr_ticket_section_parts_help(inputs)
	return de_ticket_section_parts_help(inputs)
});